import React from 'react';
import PropTypes from 'prop-types';

import { useCountdown } from '../../hooks/use-countdown';

import './CountdownTimer.css';

const SHOW_SECONDS_ALSO_AFTER_MINUTES = '3';

const renderTimeCounter = (days, hours, minutes, seconds) => {
  if (days > 1) {
    return `${days} d${hours > 0 ? ` ${hours} h` : ''}`;
  }

  if (days === 1) {
    return `${days} d${hours > 0 ? ` ${hours} h` : ''}`;
  }

  if (hours > 0) {
    return `${hours} h${minutes > 0 ? ` ${minutes} m` : ''}`;
  }

  if (minutes > SHOW_SECONDS_ALSO_AFTER_MINUTES) {
    return `${minutes} m`;
  }

  if (minutes > 0 && minutes <= SHOW_SECONDS_ALSO_AFTER_MINUTES) {
    return `${minutes} m ${seconds > 0 ? ` ${seconds} s` : ''}`;
  }

  if (seconds >= 0) {
    return `${seconds} s`;
  }

  return '0 s';
};

function CountdownTimer({
  targetDate,
  leftText,
  hideTimer,
  onTimerExpired,
  dataTestId,
}) {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);

  if (days + hours + minutes + seconds < 0) {
    if (new Date(targetDate).getTime() - new Date().getTime() <= 0) {
      onTimerExpired();
    }

    return '';
  }

  return (
    !hideTimer && (
      <span className='CountdownTimer-display' data-testid={dataTestId}>
        <span>{renderTimeCounter(days, hours, minutes, seconds)}</span>
        <span>{leftText}</span>
      </span>
    )
  );
}

CountdownTimer.defaultProps = {
  hideTimer: false,
  onTimerExpired: () => {},
  dataTestId: null,
};

CountdownTimer.propTypes = {
  targetDate: PropTypes.string.isRequired,
  leftText: PropTypes.string.isRequired,
  hideTimer: PropTypes.bool,
  onTimerExpired: PropTypes.func,
  dataTestId: PropTypes.string,
};

export default CountdownTimer;
